// import anime from 'animejs';
// import imagesLoaded from "imagesloaded";
import AOS from "aos";

export default {
  init() {
    // JavaScript to be fired on the home page

    // jQuery(document).ready(() => {
    //   setTimeout(() => {
    //   this.portfolio();
    //   this.exits();
    //   }, 3000);
    // });

    AOS.init({
      offset: -40,
      duration: 800,
      easing: 'ease',
      once: true,
    });

    jQuery(document).ready(($) => {
      var delay1 = 0;
      $('.hero [data-aos]').each(function () {
        delay1 = delay1 + 200;
        $(this).attr('data-aos-delay', delay1);
      });

      var delay2 = 0;
      $('.our-mission [data-aos]').each(function () {
        delay2 = delay2 + 200;
        $(this).attr('data-aos-delay', delay2);
      });

      var delay3 = 0;
      $('.our-approach [data-aos]').each(function () {
        delay3 = delay3 + 200;
        $(this).attr('data-aos-delay', delay3);
      });

      // var delay4 = 0;
      // $('#portfolio-archive [data-aos]').each(function () {
      //   delay4 = delay4 + 200;
      //   $(this).attr('data-aos-delay', delay4);
      // });

      // var delay5 = 0;
      // $('#exits-archive [data-aos]').each(function () {
      //   delay5 = delay5 + 200;
      //   $(this).attr('data-aos-delay', delay4);
      // });

      var delay6 = 0;
      $('#our-team [data-aos]').each(function () {
        delay6 += 200;
        $(this).attr('data-aos-delay', delay6);
      });

      var delay7 = 0;
      $('.locations [data-aos]').each(function () {
        delay7 = delay7 + 200;
        $(this).attr('data-aos-delay', delay7);
      });

      var delay8 = 0;
      $('.our-focus [data-aos]').each(function () {
        delay8 = delay8 + 200;
        $(this).attr('data-aos-delay', delay8);
      });

      var delay9 = 0;
      $('#insights [data-aos]').each(function () {
        delay9 = delay9 + 200;
        $(this).attr('data-aos-delay', delay9);
      });
    });
  },
  // portfolio() {
  //   const navigation = () => {
  //     // const container = document.querySelector('.portfolio__container');

  //     const init = () => {
  //      ss const wrapper = document.querySelector('#portfolio .portfolio__wrapper');
  //       const sections = document.querySelectorAll('#portfolio .portfolio__section');

  //       const height = sections[0].offsetHeight;
  //       wrapper.style.height = `${height}px`;

  //       imagesLoaded(document.body, () => {
  //         animateSection('#portfolio .company__logo');
  //       });
  //     }

  //     const createNavigation = () => {
  //       const navigation = document.querySelector('#portfolio .portfolio__nav');
  //       const sections = document.querySelectorAll('#portfolio .portfolio__section');

  //       const back = document.createElement('span');
  //       const next = document.createElement('span');

  //       back.classList.add('back-button');
  //       next.classList.add('next-button');

  //       const backText = document.createTextNode('Page:');
  //       const nextText = document.createTextNode('Next');

  //       back.appendChild(backText);
  //       next.appendChild(nextText);

  //       // navigation.append(back);

  //       const count = sections.length;
  //       for (let i = 1; i < count + 1; i++) {
  //         const dot = document.createElement('span');
  //         const page = document.createElement('span');
  //         const pageNumber = document.createTextNode(`${i}`);
  //         dot.classList.add('portfolio__nav-dot');
  //         dot.classList.add(`nav-${i}`);

  //         if (i === 1) {
  //           dot.classList.add('selected');
  //         }
  //         page.appendChild(pageNumber);
  //         dot.appendChild(page);
  //         navigation.appendChild(dot);
  //       }
  //       // navigation.append(next);
  //     }

  //     const animateSection = (targetSection) => {
  //       anime({
  //         targets: targetSection,
  //         // duration: function (t, i) {
  //         //   return 600 + i * 75;
  //         // },
  //         easing: 'easeOutExpo',
  //         // delay: function (t, i) {
  //         //   return i * 50;
  //         // },
  //         opacity: {
  //           value: [0, 1],
  //           easing: 'linear',
  //         },
  //         scale: [0, 1],
  //         translateZ: 0,
  //       });
  //     }

  //     const controls = () => {
  //       const dots = document.querySelectorAll('#portfolio .portfolio__nav-dot');
  //       // const back = document.querySelector('#portfolio .back-button');
  //       // const next = document.querySelector('#portfolio .next-button');

  //       dots.forEach((dot, index) => {
  //         dot.addEventListener('click', () => {

  //           // window.scrollTo({ top: container.getBoundingClientRect().top - document.body.getBoundingClientRect().top, left: 0, behavior: 'smooth' });
  //           const sections = document.querySelectorAll('#portfolio .portfolio__section');

  //           sections.forEach(section => {
  //             section.classList.remove('active');
  //           });
  //           dots.forEach(dot => {
  //             dot.classList.remove('selected');
  //           });

  //           // const height = sections[index].offsetHeight + 1;
  //           // wrapper.style.height = `${height}px`;
  //           sections[index].classList.add('active');
  //           dots[index].classList.add('selected');
  //           animateSection('#portfolio .portfolio__section.active .company__logo');
  //         })
  //       });
  //     }
  //     init();
  //     createNavigation();
  //     controls();
  //   }
  //   navigation();
  // },
  // exits() {
  //   const navigation = () => {
  //     // const container = document.querySelector('.portfolio__container');

  //     const init = () => {

  //       const wrapper = document.querySelector('#exits .portfolio__wrapper');
  //       const sections = document.querySelectorAll('#exits .portfolio__section');

  //       const height = sections[0].offsetHeight;
  //       wrapper.style.height = `${height}px`;

  //       imagesLoaded(document.body, () => {
  //         animateSection('#exits .company__logo');
  //       });
  //     }

  //     const createNavigation = () => {
  //       const navigation = document.querySelector('#exits .portfolio__nav');
  //       const sections = document.querySelectorAll('#exits .portfolio__section');

  //       const count = sections.length;
  //       for (let i = 1; i < count + 1; i++) {
  //         const dot = document.createElement('span');
  //         const page = document.createElement('span');
  //         const pageNumber = document.createTextNode(`${i}`);
  //         dot.classList.add('portfolio__nav-dot');
  //         dot.classList.add(`nav-${i}`);
  //         if (i === 1) {
  //           dot.classList.add('selected');
  //         }
  //         page.appendChild(pageNumber);
  //         dot.appendChild(page);
  //         navigation.appendChild(dot);
  //       }
  //     }

  //     const animateSection = (targetSection) => {
  //       anime({
  //         targets: targetSection,
  //         duration: function (t, i) {
  //           return 600 + i * 75;
  //         },
  //         easing: 'easeOutExpo',
  //         delay: function (t, i) {
  //           return i * 50;
  //         },
  //         opacity: {
  //           value: [0, 1],
  //           easing: 'linear',
  //         },
  //         scale: [0, 1],
  //         translateZ: 0,
  //       });
  //     }

  //     const controls = () => {
  //       const dots = document.querySelectorAll('#exits .portfolio__nav-dot');

  //       dots.forEach((dot, index) => {
  //         dot.addEventListener('click', () => {
  //           // window.scrollTo({ top: container.getBoundingClientRect().top - document.body.getBoundingClientRect().top, left: 0, behavior: 'smooth' });
  //           const sections = document.querySelectorAll('#exits .portfolio__section');

  //           sections.forEach(section => {
  //             section.classList.remove('active');
  //           });
  //           dots.forEach(dot => {
  //             dot.classList.remove('selected');
  //           });

  //           // const height = sections[index].offsetHeight + 1;
  //           // wrapper.style.height = `${height}px`;
  //           sections[index].classList.add('active');
  //           dots[index].classList.add('selected');
  //           animateSection('#exits .portfolio__section.active .company__logo');
  //         })
  //       });
  //     }
  //     init();
  //     createNavigation();
  //     controls();
  //   }
  //   navigation();
  // },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js